<template lang="pug">
b-tr.usage-fees-group-home-accommodation-costs-table-row
  b-td.room-name {{ roomName }}
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.rentCost"
        :name="'usage-fees-group-home--' + roomId + '-rent-cost'"
        :maxlength="10" :class="[ { noinput: _value.rentCost == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の居住費（月額）'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.mealCost"
        :name="'usage-fees-group-home--' + roomId + '-meal-cost'"
        :maxlength="10" :class="[ { noinput: _value.mealCost == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の食費（月額）'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.managementCost"
        :name="'usage-fees-group-home--' + roomId + '-management-cost'"
        :maxlength="10" :class="[ { noinput: _value.managementCost == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の管理費（月額）'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.utilityCost"
        :name="'usage-fees-group-home--' + roomId + '-utility-cost'"
        :maxlength="10" :class="[ { noinput: _value.utilityCost == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の光熱水費（月額）'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.otherCost"
        :name="'usage-fees-group-home--' + roomId + '-other-cost'"
        :maxlength="10" :class="[ { noinput: _value.otherCost == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'のその他（月額）'")
      span 円
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { AccommodationCost } from "@/commons/services/WaiterRecruitments";

/**
 * ### 介護保険対象外 料金コンポーネント（列）
 */
@Component({})
export default class UsageFeesGroupHomeAccommodationCostsTableRow extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: AccommodationCost;

  @Prop()
  roomId!: string;
  @Prop()
  roomName!: string;

  get _value(): AccommodationCost {
    return this.value;
  }

  set _value(newValue: AccommodationCost) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.usage-fees-group-home-accommodation-costs-table-row {
  .room-name {
    width: 140px;
  }

  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }
}
</style>
